var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jiaocheng"},[_c('title-top',[_vm._v("新手教程")]),_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("images/sqjq.png"),"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }